/*
    Create By fanglijuan 2017-05-25
    组织同步相关服务
*/
'use strict';
angular.module("accountSynchroToGroupServiceModule", ["createAccountSynchroToGroupModule", "modifyAccountSynchroToGroupModule", "deleteAccountSynchroToGroupModule", "moveAccountSynchroToGroupModule", "sortAccountSynchroToGroupModule"])
    .factory("accountSynchroToGroupService", ["$modal", '$q', function($modal, $q) {
        return {
            //新增组织同步
            addSynchroToGroup: function(item) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/groupUserManageMent/accountSynchro/toGroup/service/create/create_tpl.html",
                    windowClass: 'userManageMent-createAccountSynchroToGroup-window',
                    backdrop: false,
                    controller: "createAccountSynchroToGroupCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
            //修订组织同步
            modifySynchroToGroup: function(item) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/groupUserManageMent/accountSynchro/toGroup/service/modify/modify_tpl.html",
                    windowClass: 'userManageMent-modifyAccountSynchroToGroup-window',
                    backdrop: false,
                    controller: "modifyAccountSynchroToGroupCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
            //删除组织同步
            deleteSynchroToGroup: function(item) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/groupUserManageMent/accountSynchro/toGroup/service/delete/delete_tpl.html",
                    windowClass: 'userManageMent-deleteAccountSynchroToGroup-window',
                    backdrop: false,
                    controller: "deleteAccountSynchroToGroupCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
            //移动组织同步
            moveSynchroToGroup: function(item) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/groupUserManageMent/accountSynchro/toGroup/service/move/move_tpl.html",
                    windowClass: 'userManageMent-moveAccountSynchroToGroup-window',
                    backdrop: false,
                    controller: "moveAccountSynchroToGroupCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
            //排序组织同步
            sortSynchroToGroup: function(item) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/groupUserManageMent/accountSynchro/toGroup/service/sort/sort_tpl.html",
                    windowClass: 'userManageMent-sortAccountSynchroToGroup-window',
                    backdrop: false,
                    controller: "sortAccountSynchroToGroupCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
        };
    }]);
